import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ds-carousel-indicator" }
const _hoisted_2 = { class: "ds-carousel-indicator__dots" }
const _hoisted_3 = ["onClick"]

import { computed } from "vue";
import { useTicketFamilySlider } from "../composables/use-ticket-family-slider";


export default /*@__PURE__*/_defineComponent({
  __name: '_ticket-family-slider-dots',
  setup(__props) {

const { slider, current, slideCount } = useTicketFamilySlider();

const dotHelper = computed(() => [...Array(slideCount.value ?? 3).keys()]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dotHelper.value, (_slide, idx) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["dot", { 'is-selected': _unref(current) === idx }]),
          key: idx,
          onClick: ($event: any) => (_unref(slider).moveToIdx(idx))
        }, null, 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})